export const COUNT_DOWN_TIMER_CSS_BLOCK = 'bb-count-down-timer';
export const COUNT_DOWN_TIMER_CLASS_WARNING_1 = `${COUNT_DOWN_TIMER_CSS_BLOCK}--warning-1`;
export const COUNT_DOWN_TIMER_CLASS_WARNING_2 = `${COUNT_DOWN_TIMER_CSS_BLOCK}--warning-2`;
export const COUNT_DOWN_TIMER_CLASS_WAIT = `${COUNT_DOWN_TIMER_CSS_BLOCK}--wait`;
export const TIME_ZONE_LABEL = 'Europe/Dublin';
export const COUNT_DOWN_TIMER_ZERO = 0;
export const COUNT_DOWN_TIMER_INTERVAL = 1000;
export const COUNT_DOWN_FINISHED = '00:00';

/**
 * Default times are in milliseconds
 * 1800 seconds = 30 minutes
 * 300 seconds = 5 minutes
 */
export const COUNT_DOWN_TIMER_WARNING_1 = 1800;
export const COUNT_DOWN_TIMER_WARNING_2 = 300;
